/** Normalize score to { homeScore, awayScore } */
export function parseScore(score) {
  if (!score) return null;
  if (typeof score === 'object' && 'homeScore' in score && 'awayScore' in score) {
    return { homeScore: Number(score.homeScore), awayScore: Number(score.awayScore) };
  }
  if (typeof score === 'string' && score.includes(':')) {
    const [h, a] = score.split(':').map((x) => parseInt(x, 10));
    if (Number.isFinite(h) && Number.isFinite(a)) return { homeScore: h, awayScore: a };
  }
  return null;
}

/** @returns {'exact'|'outcome'|'wrong'|'pending'} */
export function getPredictionTier(predicted, finalResult) {
  const p = parseScore(predicted);
  const f = parseScore(finalResult);
  if (!p || !f) return 'pending';
  if (p.homeScore === f.homeScore && p.awayScore === f.awayScore) return 'exact';
  const pw = p.homeScore > p.awayScore ? 'home' : p.homeScore < p.awayScore ? 'away' : 'draw';
  const fw = f.homeScore > f.awayScore ? 'home' : f.homeScore < f.awayScore ? 'away' : 'draw';
  if (pw === fw) return 'outcome';
  return 'wrong';
}

/** Semantic order: always home – away (do not use for on-screen RTL). */
export function formatScoreDisplay(score) {
  const p = parseScore(score);
  if (!p) return '—';
  return `${p.homeScore} – ${p.awayScore}`;
}

/**
 * Visual order next to matchups: Hebrew RTL puts home on the right,
 * so the left number must be away.
 */
export function formatScoreVisual(score, isRTL) {
  const p = parseScore(score);
  if (!p) return '—';
  if (isRTL) return `${p.awayScore} – ${p.homeScore}`;
  return formatScoreDisplay(score);
}
